module.exports = __webpack_public_path__ + "static/media/amp-guitar.5f2bd855.svg";